import { Brand, createBranded } from '@deltasierra/type-utilities';

export type TagId = Brand<number, 'TagId'>;
export const TagId = createBranded<TagId>();
